import React from 'react'

export default function footer() {
  return (
    <>
    <footer className="footer">
        <p>© {new Date().getFullYear()} MyWebsite — All rights reserved.</p>
        <div className="footer-links">
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
          <a href="#">Contact</a>
        </div>
      </footer>
    </>
   
  )
}
